import clsx from 'clsx';
import React from 'react';

const TabLink = ({ selected, children }) => {
  return (
    <div
      className={clsx(
        `relative group border-b-2 border-transparent transition-[background-color]  ease-out focus:outline-none focus:border-chocolate-600 ring-0 font-medium hover:text-chocolate-600 -m-2 p-2 rounded-md hover:bg-gray-50`,
        {
          '!text-chocolate-600 !border-chocolate-600 rounded-b-none': selected,
        },
      )}
    >
      {children}
    </div>
  );
};

export default TabLink;
